import { AuthCallback } from "@/pages/AuthCallback";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/authCallback")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { code?: string; error?: string; redirect?: string } => {
    return {
      code: search.code as string | undefined,
      error: search.error as string | undefined,
      redirect: search.redirect as string | undefined,
    };
  },
  component: AuthCallback,
});
